import Model, { attr, belongsTo } from '@ember-data/model';
import { copyable } from 'eflex/decorators';

@copyable
class HardwareInputDefConfig extends Model {
  @attr('string') state;
  @attr('boolean', { defaultValue: false }) changeState;

  @belongsTo('task-config', { async: false, inverse: 'hardwareInputDefConfigs' }) taskConfig;
  @belongsTo('hardware-input-def', { async: false, inverse: 'hardwareInputDefConfigs' }) hardwareInputDef;

  get copyableOptions() {
    return {
      ignoreAttributes: new Set(['hardwareInputDef', 'taskConfig']),
    };
  }
}

export default HardwareInputDefConfig;
